import { render } from "./MessagesTableRowStatusBadge.vue?vue&type=template&id=0364d493"
import script from "./MessagesTableRowStatusBadge.vue?vue&type=script&lang=js"
export * from "./MessagesTableRowStatusBadge.vue?vue&type=script&lang=js"

import exportComponent from "/home/dschranka/actions-runner/_work/DSchranka/DSchranka/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__